import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import React from "react";

// VFX: Subscribe Bell Outro
// Category: intros-outros · Tags: outro, subscribe, bell, youtube, cta
export default function CtaSubscribeBellOutro2000Ms() {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();
  const btn = spring({ frame, fps, config: { damping: 14 } });
  const bell = spring({ frame: frame - 25, fps, config: { damping: 10, mass: 0.5 } });
  const wiggle = Math.sin((frame - 40) * 0.6) * interpolate(frame, [40, 60, durationInFrames], [0, 12, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const thumbs = spring({ frame: frame - 35, fps, config: { damping: 12 } });
  return (
    <AbsoluteFill style={{ background: "linear-gradient(180deg, #0a0e1a 0%, #1a0a1a 100%)", justifyContent: "center", alignItems: "center", gap: 60 }}>
      <div style={{
        background: "#ef4444", color: "#fff", padding: "32px 80px", borderRadius: 12,
        fontSize: 64, fontWeight: 900, fontFamily: "Inter", letterSpacing: 2,
        transform: `scale(${btn})`, boxShadow: "0 12px 60px rgba(239,68,68,0.5)",
      }}>SUBSCRIBE</div>
      <div style={{
        width: 160, height: 160, borderRadius: 80, background: "#1e293b",
        display: "flex", alignItems: "center", justifyContent: "center",
        transform: `scale(${bell}) rotate(${wiggle}deg)`,
        border: "4px solid #f8fafc",
      }}>
        <svg width="80" height="80" viewBox="0 0 24 24" fill="#fbbf24">
          <path d="M12 2a2 2 0 0 0-2 2v.5C7.7 5.4 6 7.5 6 10v5l-2 2v1h16v-1l-2-2v-5c0-2.5-1.7-4.6-4-5.5V4a2 2 0 0 0-2-2zm0 20a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2z"/>
        </svg>
      </div>
      <div style={{
        position: "absolute", right: 200, top: 400,
        fontSize: 120, transform: `scale(${thumbs}) rotate(${interpolate(thumbs, [0, 1], [-30, 0])}deg)`,
      }}>👍</div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
